import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col pb-20 tablet:flex-row-reverse tablet:items-start" }
const _hoisted_2 = { class: "tablet:w-3/4" }

import KalendarSvazu from "@/components/Kalendar/KalendarSvazu.vue";
import YearCalendar from "@/components/Kalendar/YearCalendar.vue";
import {Competition} from "@/interfaces/interfaces";
import zavody from "../../public/data/zavody";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {


const arrayRange = (start: number, stop: number, step: number) =>
    Array.from(
        { length: (stop - start) / step + 1 },
        (value, index) => start + index * step
    );

const yearsToRender =  arrayRange(new Date().getFullYear(), 2023, -1)

function getCompetitionsOfYear(year: number){
  return zavody.filter((comp) => comp.date.endsWith(year.toString()))
}

const calendar = [
  {
    year: 2023,
    events: [
      {
        date: '28.11.2023',
        name: 'Trasko CUP',
        results: 'swjhdbieud'
      } as Competition,
      {
        date: '15.5.2023',
        name: 'Traskáček',
      } as Competition,
      {
        date: '18.4.2023',
        name: 'O pohár města Vyškova',
      } as Competition,
      {
        date: '4.5.2023',
        name: 'Veselská panenka',
      } as Competition,
      {
        date: '30.5.2023',
        name: 'Žďárská Sněženka',
      } as Competition,


    ]
  },
  {
    year: 2022,
    events: [
      {
        date: '28.11.2022',
        name: 'Trasko CUP',
      } as Competition,
      {
        date: '30.5.2022',
        name: 'Traskáček',
      } as Competition,
      {
        date: '18.4.2022',
        name: 'O pohár města Vyškova',
      } as Competition,
    ]
  }
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(KalendarSvazu, { class: "tablet:w-1/4 tablet:py-10" }),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(yearsToRender), (year) => {
        return (_openBlock(), _createBlock(YearCalendar, {
          key: year,
          year: year,
          events: getCompetitionsOfYear(year)
        }, null, 8, ["year", "events"]))
      }), 128))
    ])
  ]))
}
}

})